import { generateSlug } from "@/lib/utils";
import { ScrollLink } from "@/components/ui/scroll-link";
import type { Author } from "@/types";

interface FeaturedAuthorsProps {
  authors: Author[];
}

export function FeaturedAuthors({ authors }: FeaturedAuthorsProps) {
  return (
    <section>
      <h2 className="mb-8 text-3xl font-bold tracking-tight">Featured Authors</h2>
      <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3">
        {authors.map((author) => (
          <ScrollLink
            key={author.id}
            to={`/authors/${author.slug}`}
            className="group relative flex flex-col items-center"
          >
            <div className="relative h-40 w-40 overflow-hidden rounded-full">
              {author.picture ? (
                <img
                  src={author.picture}
                  alt={author.name}
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
              ) : (
                <div className="flex h-full w-full items-center justify-center bg-gray-200">
                  <span className="text-lg text-gray-500">No image</span>
                </div>
              )}
            </div>
            <h3 className="mt-4 text-center text-xl font-medium">{author.name}</h3>
          </ScrollLink>
        ))}
      </div>
    </section>
  );
} 